import get_title from "@/router/module/get_title";
import NomenclatureModelRouterHook from "@/new/auth/nomenclature-model.router-hook";

export default {
  path: "/content/nomenclature/:productId/categories",
  name: "product-edit__categories",
  meta: {
    title: get_title("Товар | Категории"),
    forVisitors: true,
    requiresAuth: true
  },
  component: () => import("@/new/pages/nomenclature/edit/categories.vue"),
  beforeEnter: NomenclatureModelRouterHook("product.show-categories"),
};
